import React from 'react';
import styled from 'styled-components';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import MotifIcon from './MotifIcon';
import MotifButton from './MotifButton';
import {buttonLabelDirections} from '../../../util/uiconstants';

export default function IconButton(props) {
	const {
		id,
		key,
		ariaControls,
		ariaExpanded,
		ariaLabel,
		dataTestId,
		type,
		className,
		onClick,
		disabled,
		href,
		size,
		title,
		children,
		iconId,
		iconClassName,
		iconTitle,
		iconType,
		iconSource,
		iconFunction,
		onIconClick,
		showLabel,
		isEllipsed,
		buttonLabel,
		labelClassName,
		noOfLines,
		variant,
		labelDirection = buttonLabelDirections.right
	} = props;

	const _label = (
		<React.Fragment>
			{showLabel &&
				(isEllipsed ? (
					<EllipseControl content={buttonLabel} tooltip={buttonLabel} noOfLines={noOfLines} />
				) : (
					<span className={labelClassName}>{buttonLabel}</span>
				))}
		</React.Fragment>
	);

	return (
		<StyledMotifIconButton
			id={id}
			key={key}
			type={type}
			title={title}
			className={className}
			disabled={disabled}
			onClick={onClick}
			href={href}
			size={size}
			aria-controls={ariaControls}
			aria-expanded={ariaExpanded}
			aria-label={ariaLabel}
			data-testid={dataTestId}
			variant={variant ? variant : 'ghost'}
		>
			{children ? (
				children
			) : (
				<>
					{labelDirection === buttonLabelDirections.left && _label}
					<MotifIcon
						id={iconId}
						className={iconClassName}
						title={iconTitle}
						type={iconType}
						src={iconSource}
						onClick={onIconClick}
						iconFunction={iconFunction}
					/>
					{labelDirection === buttonLabelDirections.right && _label}
				</>
			)}
		</StyledMotifIconButton>
	);
}

const StyledMotifIconButton = styled(MotifButton)`
	display: flex;
	gap: var(--px-8);
	&[disabled] {
		.motif-icon svg {
			fill: var(--ui-foreground-disabled) !important;
		}
	}
`;
